import { createContext } from "@lit/context";
import type { AuthStore } from "../stores/auth.store";

export type AuthContext = AuthStore;
export const authContext = createContext<AuthContext>(Symbol("auth-context"));